/* eslint-disable import/prefer-default-export */
import React from 'react'

import s from './NewestFeature.module.css'
import latestFeature from './latestFeature.jpg'

export function NewestFeature() {
  return (
    <div className={s.root}>
      <div className={s.title}>Newest feature</div>

      <div className={s.latestFeatureImageWrapper}>
        <img src={latestFeature} alt="Apply" className={s.latestFeatureImage} />
      </div>

      <div className={s.latestFeatureTitle}>Apply</div>
      <div className={s.latestFeatureText}>
        Applying for an apartment in New York can be complex, but Nooklyn simplifies the process with our streamlined
        application system.
      </div>
    </div>
  )
}
